import { WrappedError } from './wrapped-error';

/**
 * Error to be thrown when a SerializableObject can not be created.
 */
export class SerializableObjectBuildError extends WrappedError {
  public readonly name: string = 'SerializableObjectBuildError';
}
